export const CHANGE_CATEGORY=  "CHANGE_CATEGORY";
export const GET_CATEGORIES_SUCCESS= "GET_CATEGORIES_SUCCESS";
export const GET_PRODUCTS_SUCCESS="GET_PRODUCTS_SUCCESS"

export const ADD_TO_CART="ADD_TO_CART"
export const REMOVE_TO_CART="REMOVE_TO_CART"


export const CREATE_PRODUCTS_SUCCESS="CREATE_PRODUCTS_SUCCESS"
export const UPDATE_PRODUCTS_SUCCESS="UPDATE_PRODUCTS_SUCCESS"

export const IS_LOADING="IS_LOADING"